// import Link from "next/link";
import { ICMS } from "@/types/home.types";

export default function LinksSection({ cmsData }: { cmsData: ICMS }) {
  // const travelFrom = [
  //   "Ahmedabad to Rann Utsav",
  //   "Mumbai to Rann Utsav",
  //   "Delhi to Rann Utsav",
  //   "Bangalore to Rann Utsav",
  //   "Pune to Rann Utsav",
  //   "Surat to Rann Utsav",
  // ];

  // const rannUtsavTentCity = [
  //   "Rann Tent Resort",
  //   "White Rann Resort",
  //   "Dhordo Tent City",
  // ];

  // const dholaviraTentCity = [
  //   "White Rann The Tent City",
  //   "Evoke Dholavira",
  //   "Praveg Resort Dholavira",
  //   "Rann Resort Dholavira",
  // ];

  // const souTickets = [
  //   "Statue Of Unity Day Package with Viewing Gallery",
  //   "SOU Day Package Viewing Gallery With Full Day E-Rickshaw",
  //   "SOU Viewing Gallery",
  //   "2ND Day Package",
  //   "2ND Day Package by E-Rickshaw",
  // ];

  // const souPackages = [
  //   "Villa Euphoria Package 1 Night 2 Days",
  //   "Riverview Tent Resort Package 1 Night 2 Days",
  //   "Tent City Narmada 1 Night 2 Days",
  //   "Hotel Sai Inn Package 1 Night 2 Days",
  //   "Unity Village Resort Package 1 Night 2 Days",
  //   "Unity Home Package 2 Nights 3 Days",
  //   "Haritha Hill Resort Package 2 Nights 3 Days",
  //   "Vrundaa Ekta Manor Package 2 Nights 3 Days",
  // ];

  // const gujaratPackages = [
  //   "Dwarka Somnath Package 3 Nights 4 Days",
  //   "Dwarka Somnath Package 4 Nights 5 Days",
  //   "Gujarat Best 4 Nights 5 Days",
  //   "Gujarat Package 8 Nights 9 Days",
  //   "Dwarka Somnath Package 4 Nights 5 Days",
  //   "Ahmedabad Dwarkadish Package 3 Nights 4 Days",
  //   "Ahmedabad Package 2 Nights 3 Days",
  //   "Rann Utsav Package 2 Nights 3 Days",
  // ];

  return (
    <section className="py-12 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4">
        <div
          className="text-sm"
          dangerouslySetInnerHTML={{ __html: cmsData?.Template }}
        />

        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 text-sm">

          <div>
            <h3 className="mb-4">Travel From:</h3>
            <div className="flex flex-wrap gap-2">
              {travelFrom.map((link, index) => (
                <Link
                  key={index}
                  href="#"
                  className="text-gray-600 hover:text-pink-600 transition"
                >
                  {link}
                  {index < travelFrom.length - 1 && " |"}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4">Rann Utsav Tent City:</h3>
            <div className="flex flex-wrap gap-2">
              {rannUtsavTentCity.map((link, index) => (
                <Link
                  key={index}
                  href="#"
                  className="text-gray-600 hover:text-pink-600 transition"
                >
                  {link}
                  {index < rannUtsavTentCity.length - 1 && " |"}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4">Dholavira Tent City:</h3>
            <div className="flex flex-wrap gap-2">
              {dholaviraTentCity.map((link, index) => (
                <Link
                  key={index}
                  href="#"
                  className="text-gray-600 hover:text-pink-600 transition"
                >
                  {link}
                  {index < dholaviraTentCity.length - 1 && " |"}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4">SOU Tickets:</h3>
            <div className="flex flex-wrap gap-2">
              {souTickets.map((link, index) => (
                <Link
                  key={index}
                  href="#"
                  className="text-gray-600 hover:text-pink-600 transition"
                >
                  {link}
                  {index < souTickets.length - 1 && " |"}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4">SOU Packages:</h3>
            <div className="flex flex-wrap gap-2">
              {souPackages.map((link, index) => (
                <Link
                  key={index}
                  href="#"
                  className="text-gray-600 hover:text-pink-600 transition"
                >
                  {link}
                  {index < souPackages.length - 1 && " |"}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4">Gujarat Packages:</h3>
            <div className="flex flex-wrap gap-2">
              {gujaratPackages.map((link, index) => (
                <Link
                  key={index}
                  href="#"
                  className="text-gray-600 hover:text-pink-600 transition"
                >
                  {link}
                  {index < gujaratPackages.length - 1 && " |"}
                </Link>
              ))}
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
}
